import { render, staticRenderFns } from "./share1.vue?vue&type=template&id=750b596a&scoped=true"
import script from "./share1.vue?vue&type=script&lang=js"
export * from "./share1.vue?vue&type=script&lang=js"
import style0 from "./share1.vue?vue&type=style&index=0&id=750b596a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b596a",
  null
  
)

export default component.exports